import React, { useEffect, useState, memo } from "react";
import { Close } from "@mui/icons-material";

export const ThumbnailPlaceholder = memo(
  ({ index, file, onDelete, provided, snapshot }) => {
    const [objectUrl, setObjectUrl] = useState(null);

    useEffect(() => {
      if (!file) return;

      let url = null;

      // Case 1: File (new upload)
      if (file instanceof File) {
        url = URL.createObjectURL(file);
        setObjectUrl(url);
        return () => URL.revokeObjectURL(url);
      }

      // Case 2: Object with `image`
      if (typeof file === "object" && file.image) {
        setObjectUrl(file.image);
      }

      // Case 3: Plain string URL
      if (typeof file === "string") {
        setObjectUrl(file);
      }
    }, [file]);

    return (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        className="thumbnail-placeholder"
        title={index === 0 ? "This will be your default thumbnail" : ""}
        style={{
          width: "100px",
          height: "100px",
          position: "relative",
          borderRadius: "0.5rem",
          border: index === 0 ? "3px dotted #000000" : "2px dashed #DBD9D4",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: file ? "transparent" : "#F8F9FA",
          transform: snapshot.isDragging ? "scale(1.05)" : "none",
          transition: "transform 0.2s cubic-bezier(0.2, 0, 0, 1)",
          willChange: "transform",
          ...provided.draggableProps.style,
        }}
      >
        {file ? (
          <>
            <button
              className="delete-button"
              onClick={() => onDelete(index)}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                zIndex: 2,
                padding: 0,
                width: "20px",
                height: "20px",
                border: "none",
                borderRadius: "50%",
                backgroundColor: "black",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Close sx={{ color: "white", fontSize: "14px" }} />
            </button>
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              src={objectUrl}
              alt={`Thumbnail ${index + 1}`}
            />
          </>
        ) : (
          <span style={{ color: "#ADB5BD", fontSize: "14px" }}>
            {index + 1}
          </span>
        )}
      </div>
    );
  }
);

ThumbnailPlaceholder.displayName = "ThumbnailPlaceholder";

